/**
 * Mypawshop – bundelväljare.
 * Väljer paket och skickar kunden till kassan via cart-permalink
 * (/cart/VARIANT:1) som ERSÄTTER varukorgens innehåll — annars
 * ackumuleras gamla val och fel produkter följer med till kassan.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-mp-bundle-selector]').forEach(function (root) {
    var form = root.querySelector('[data-mp-bundle-form]');
    var submitBtn = root.querySelector('[data-mp-bundle-submit]');
    var cards = root.querySelectorAll('[data-mp-bundle-card]');

    function selectedCard() {
      return root.querySelector('[data-mp-bundle-card].is-selected') || cards[0];
    }

    function selectCard(card) {
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
        var radio = c.querySelector('input[type="radio"]');
        if (radio) radio.checked = false;
      });
      card.classList.add('is-selected');
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;

      document.dispatchEvent(new CustomEvent('mypashow:bundle:selected', {
        detail: {
          variantId: card.getAttribute('data-variant-id'),
          title: card.getAttribute('data-title'),
          price: card.getAttribute('data-price'),
          compareAtPrice: card.getAttribute('data-compare-at-price')
        }
      }));
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { selectCard(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectCard(card); }
      });
    });

    // Förvalet sänds först på DOMContentLoaded så att ALLA deferred lyssnare
    // (t.ex. sticky-raden, vars script laddas senare i dokumentet) hunnit
    // registrera sig. OBS: defer-script kör vid readyState 'interactive',
    // så vi väntar i alla lägen utom 'complete'.
    var preselected = root.querySelector('[data-mp-bundle-card][data-preselect="true"]') || cards[0];
    function initSelect() { if (preselected) selectCard(preselected); }
    if (document.readyState === 'complete') {
      initSelect();
    } else {
      document.addEventListener('DOMContentLoaded', initSelect);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var card = selectedCard();
        if (!card) return;
        var variantId = card.getAttribute('data-variant-id');

        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute('data-loading-text') || 'Till kassan …';

        // Cart-permalink: tömmer varukorgen, lägger i valt paket, öppnar kassan
        window.location.href = '/cart/' + variantId + ':1';
      });
    }
  });
})();
